import { SMS_AUTO_RECHARGE_CAP_PRESETS } from '@interfaces/sms-credits';
import { convertPrice } from '@utils/resource';
import { InputNumber, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

export const SMS_CAP_CUSTOM = 'custom';

type Props = {
    disabled: boolean;
    adminMax: number | null;
    choice: number | typeof SMS_CAP_CUSTOM | undefined;
    onChoice: (v: number | typeof SMS_CAP_CUSTOM) => void;
    customUsd: number | null;
    onCustomUsd: (v: number | null) => void;
    error: string | null;
};

// Monthly cap picker: presets ($100..$2500) or a custom USD amount, bounded by the admin max cap.
export const SmsAutoRechargeCapField: React.FC<Props> = ({
    disabled,
    adminMax,
    choice,
    onChoice,
    customUsd,
    onCustomUsd,
    error,
}) => {
    const { t } = useTranslation(['marketplace']);
    const options = [
        ...SMS_AUTO_RECHARGE_CAP_PRESETS.map((c) => ({
            value: c,
            label: convertPrice(c),
            disabled: adminMax != null && c > adminMax,
        })),
        { value: SMS_CAP_CUSTOM, label: t('smsCredits.autoRecharge.customCap') },
    ];

    return (
        <div>
            <label className="sms-ar-label" id="sms-ar-cap">
                {t('smsCredits.autoRecharge.monthlyCap')}
            </label>
            <Select
                aria-labelledby="sms-ar-cap"
                status={error ? 'error' : undefined}
                style={{ width: '100%' }}
                disabled={disabled}
                value={choice}
                onChange={onChoice}
                placeholder={t('smsCredits.autoRecharge.select')}
                options={options}
            />
            {choice === SMS_CAP_CUSTOM && (
                <InputNumber
                    style={{ width: '100%', marginTop: 8 }}
                    aria-label={t('smsCredits.autoRecharge.customCap')}
                    prefix="$"
                    min={1}
                    max={adminMax != null ? adminMax / 100 : undefined}
                    precision={0}
                    disabled={disabled}
                    value={customUsd}
                    onChange={onCustomUsd}
                />
            )}
            {error && (
                <Typography.Text
                    type="danger"
                    role="alert"
                    style={{ display: 'block', marginTop: 4 }}
                >
                    {error}
                </Typography.Text>
            )}
        </div>
    );
};
